var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2557 8.35117C16.2425 3.93291 12.6502 0.361886 8.2319 0.375064C3.81364 0.388243 0.242617 3.98063 0.255795 8.39889C0.267705 12.3919 3.20305 15.6928 7.02934 16.2815L7.01266 10.6912L4.98142 10.6973L4.97452 8.38482L7.00577 8.37876L7.00051 6.61627C6.99453 4.61127 8.18556 3.50022 10.0129 3.49477C10.8882 3.49216 11.8042 3.64567 11.8042 3.64567L11.81 5.61442L10.8013 5.61742C9.80747 5.62039 9.49939 6.23798 9.50128 6.87064L9.50575 8.3713L11.7245 8.36468L11.3767 10.6782L9.51265 10.6838L9.52933 16.274C13.352 15.6625 16.2676 12.3442 16.2557 8.35117Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c3c32763e989d882b9de4cf0bd835a2f.svg";
export { ForwardRef as ReactComponent };